/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import useDebounce from '../../../common/components/UseDebounce';
import SystemModulesContent from './SystemModulesContent';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import UpdateApplicationStatusModal from '../components/UpdateApplicationStatusModal';
import CreateApplicationStatusModal from '../components/CreateApplicationStatusModal';

const form = {
  keyword: '',
};

function SystemModulesContainer({
  match,
  history,
  getRequirementList,
  moduleList,
  moduleListPager,
  isLoading,
  removeRequirement,
  removeApplicationStatus,
  showRequirement
}) {

  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add System Module',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update System Module',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this system module?',
      () => {
        removeRequirement(data.id, () => {
          getRequirementList();
          const id = _.get(moduleList, '0.id');
          history.push(`/general-settings/system-modules/${id}`);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleAddApplicationStatusModal = (id) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateApplicationStatusModal id={id} />,
      title: 'Add Application Status',
      modalSize: 'modal-md',
    });
  };

  const handleApplicationStatusEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateApplicationStatusModal applicationStatus={data} />,
      title: 'Update Application Status',
      modalSize: 'modal-md',
    });
  };

  const handleApplicationStatusRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this application status?',
      () => {
        removeApplicationStatus(data, () => {
          getRequirementList();
          history.push(`/general-settings/system-modules/${data.system_module_id}`);
          showRequirement(data.system_module_id);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };


  useEffect(() => {
    getRequirementList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getRequirementList({ name: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:moduleId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Modules List"
            getData={getRequirementList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search modules..."
            pathName={`${match.path}/:moduleId?`}
            listName="modules"
            label="System Modules List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                {_.get(item, 'attributes.description')}
              </div>
            )}
            isLoading={isLoading}
            selected={params.moduleId}
            data={moduleList}
            dataPager={moduleListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:moduleId?`}
                    render={() => (
                      <SystemModulesContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        handleAddApplicationStatusModal={handleAddApplicationStatusModal}
                        handleApplicationStatusEdit={handleApplicationStatusEdit}
                        handleApplicationStatusRemove={handleApplicationStatusRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:moduleId?`}
                  render={() =>
                    !params.moduleId && moduleList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(moduleList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

SystemModulesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  moduleList: PropTypes.instanceOf(Array).isRequired,
  moduleListPager: PropTypes.instanceOf(Object).isRequired,
  removeRequirement: PropTypes.instanceOf(Function).isRequired,
  removeApplicationStatus: PropTypes.instanceOf(Function).isRequired,
  showRequirement: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  moduleList: _.get(api, `${c.GET_REQUIREMENT}.list`) || [],
  moduleListPager: _.get(api, `${c.GET_REQUIREMENT}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_REQUIREMENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SystemModulesContainer);
